import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from '../../../config/site';
import './ManagePeople.css';
import ButtonGroup from '../../molecules/ButtonGroup';
import Button from '../../atoms/Button';
import PeopleList from '../PeopleList';
import Icon from '../../atoms/Icon';

const mapToArray = (peopleObj) => {
  if ( !peopleObj ) return [];
  return Object.keys(peopleObj).filter(id => {
    return peopleObj[id] !== null;
  }).map(id => {
    return {
      ...peopleObj[id],
      personId: id,
    };
  });
};

class ManagePeople extends Component {

  constructor(...args) {
    super(...args);
    this.state = {
      error: '',
    };
  }

  componentWillMount() {
    this.setState({
      peopleSorted: mapToArray(this.props.peopleEdit),
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      peopleSorted: mapToArray(nextProps.peopleEdit),
    });
  }

  hasAStag(people) {
    let personId;
    if ( !people ) return false;
    const keys = Object.keys(people);
    if ( !keys.length ) return false;
    for ( personId in people ) {
      if ( people[personId] && people[personId].role === "stag" ) {
        return true;
      }
    }
    return false;
  }

  render() {

    const that = this;
    const {people, peopleEdit, saving, loading, addPerson, cancelEditPeople} = this.props;
    const {peopleSorted, error} = this.state;

    const editPeople = () => {
      this.props.editPeople(people);
    };

    const savePeople = () => {
      if ( this.hasAStag(peopleEdit) ) {
        this.setState({
          error: '',
        }, () => {
          this.props.savePeople(peopleEdit);
        });
      } else {
        this.setState({
          error: "Must have a stag!",
        });
      }
    };

    if ( saving ) {
      return (
        <div>Saving...</div>
      );
    } else if ( loading && !(Object.keys(people).length > 0) ) {
      return (
        <div>Loading...</div>
      );
    }

    const roles = [
      ...config.roles,
    ];

    const attendanceOptions = [
      {
        value: true,
        label: <Icon icon="ok" />,
      },
      {
        value: false,
        label: <Icon icon="cancel" />,
      },
      {
        value: null,
        label: <Icon icon="help" />,
      },
    ];

    return (
      <div className={"ManagePeople" + (peopleEdit ? " edit" : "")}>
        {peopleEdit
          ? (
            <div>
              <div className="Person Person-Titles">
                <span name="name"> Name </span>
                <span name="role"> Role </span>
                <span name="attending"> Attending </span>
                <span name="actions"> </span>
              </div>
              {peopleSorted.map(person => {
                const id = person.personId;

                const removePerson = () => {
                  that.props.removePerson(id);
                };

                const updatePerson = (ev) => {
                  that.props.updatePerson(id, {
                    [ev.target.name]:ev.target.value,
                  });
                };

                const updateAttendance = (attending) => {
                  that.props.updatePerson(id, {
                    attending,
                  });
                };

                if ( person === null ) return null;

                return (
                  <div className="Person" key={id}>
                    <input type="text" name="name" placeholder="Name..." value={person.name || ""} onChange={updatePerson} />
                    <select name="role" value={person.role || null} onChange={updatePerson}>
                      <option value={null}> None </option>
                      {roles.map(role => {
                        return (
                          <option key={role} value={role}>{role}</option>
                        );
                      })}
                    </select>
                    <ButtonGroup
                      options={attendanceOptions}
                      value={typeof person.attending === "boolean" ? person.attending : null}
                      onChange={updateAttendance}
                      small
                    />
                    <span name="actions">
                      <Button type="delete" onClick={removePerson} small> <Icon icon="trash-empty" /> </Button>
                    </span>
                  </div>
                )
              })}
              <div className="controls">
                <Button onClick={addPerson}> Add Person </Button>
                <Button onClick={savePeople}> Save </Button>
                <Button onClick={cancelEditPeople}> Cancel </Button>
                {(error && error.length > 0) && (
                  <div>
                    <p>{error}</p>
                  </div>
                )}
              </div>
            </div>
          )
          : (
            <div>
              <PeopleList />
              <div className="controls">
                <Button onClick={editPeople}>Edit</Button>
              </div>
            </div>
          )
        }
      </div>
    );

  }

}

ManagePeople.propTypes = {
  people: PropTypes.object.isRequired,
  peopleEdit: PropTypes.object,
  saving: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  editPeople: PropTypes.func.isRequired,
  addPerson: PropTypes.func.isRequired,
  removePerson: PropTypes.func.isRequired,
  updatePerson: PropTypes.func.isRequired,
  cancelEditPeople: PropTypes.func.isRequired,
  savePeople: PropTypes.func.isRequired,
}

export default ManagePeople;



// WEBPACK FOOTER //
// ./src/component/organisms/ManagePeople/component.js